import React from 'react';
import MoreActions from '../../../../views/SupplierManager/Enhancements/components/MoreActions';

const ActionsCell = ({ actions = [] }) => {
  return <MoreActions actions={actions} />;
};

export default ActionsCell;
